import DeleteEquipment from "./DeleteEquipment";

export default DeleteEquipment;
